











import { Component, Emit, Model, Prop, Vue, Watch } from "vue-property-decorator";
import Rules from "@/app/modules/_global/classes/Rules";

@Component
export default class RadioGroup extends Vue {
  @Prop(Array) readonly items!: object;
  @Prop(String) readonly label!: string;

  @Model("input", { type: String }) readonly data!: string;

  @Emit()
  input() {
    return this.localData;
  }

  @Watch("localData")
  onLocalDataChanged() {
    this.input();
  }

  localData: string;

  rules = {
    required: Rules.required
  };

  constructor() {
    super();

    this.localData = this.data;
  }
}
